export default __webpack_public_path__ + "static/media/camera.a1409709.png";